module.exports = __webpack_public_path__ + "img/stena35.3a9416cb.jpg";